Postlogin = (function (my) {
    my.EasyLoginEdit = {};
    const self = my.EasyLoginEdit;

    self.init = function () {
        $('#edit-expiration').on('click', (e) => {
            e.preventDefault();
            $('.expiration-dropdown').removeClass('hidden');
            $('#expiration').prop('disabled', false);
            $('#cancel-edit-expiration').removeClass('hidden');
            $('#edit-expiration').addClass('hidden');
        });

        $('#cancel-edit-expiration').on('click', (e) => {
            e.preventDefault();
            $('.expiration-dropdown').addClass('hidden');
            $('#expiration').prop('disabled', true);
            $('#cancel-edit-expiration').addClass('hidden');
            $('#edit-expiration').removeClass('hidden');
        });

        $('.easy-logins-form').on('submit', (e) => {
            const selectedStudents = $('#selected-students-list');
            const errorMessage = $('.submit-error');

            if (!selectedStudents.find('li').length) {
                e.preventDefault();
                errorMessage.removeClass('hidden');

                return;
            }

            errorMessage.addClass('hidden');
        });
    };

    return my;
}(Postlogin || {}));
